import { toDate } from 'utils/converters';

const sanitizeCodigoPersonalizado = (value) =>
  String(value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9_-]/g, '')
    .replace(/\s+/g, '')
    .slice(0, 10);

const formatSecador = (dados) => {
  const {
    data_entrada,
    data_saida,
    hora_entrada,
    hora_saida,
    responsavel,
    secador,
    umidade_entrada,
    umidade_saida,
    codigoManualHabilitado,
    codigoSecagem,
  } = dados.dados;

  const codigoPersonalizado = codigoManualHabilitado
    ? sanitizeCodigoPersonalizado(codigoSecagem) || null
    : null;

  return {
    secador: secador?.id,
    lote: dados?.escolherLotes?.map((item) => {
      const payload = {
        id: item.idLote,
        codigo: item.codigo,
        quantidade: item.quantidade,
      };
      const refTipo = item.ref_tipo ?? item.refTipo;
      if (refTipo != null && refTipo !== '') payload.ref_tipo = refTipo;
      return payload;
    }),
    dataEntrada: toDate(data_entrada),
    dataSaida: data_saida && toDate(data_saida),
    horaEntrada: hora_entrada,
    horaSaida: hora_saida,
    umidadeEntrada: Number(umidade_entrada),
    umidadeSaida: Number(umidade_saida),
    responsavel,
    ...(codigoPersonalizado ? { codigo_personalizado: codigoPersonalizado } : {}),
  };
};

export { formatSecador };
